/* import __COLOCATED_TEMPLATE__ from './line-chart-with-tooltips.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();